export default __webpack_public_path__ + "static/media/codepen2.bdad6001.png";